import { CSSProperties, FC, ReactNode } from "react";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

type Props = {
  icon: React.ReactElement | ReactNode;
  label: string;
  children: ReactNode;
  containerStyle?: CSSProperties;
  containerClassName?: string;
  labelStyle?: CSSProperties;
  labelClassName?: string;
  valueStyle?: CSSProperties;
  valueClassName?: string;
};

const InlineEditField: FC<Props> = ({
  icon,
  label,
  children,
  containerStyle,
  containerClassName,
  labelStyle,
  labelClassName,
  valueStyle,
  valueClassName,
}) => {
  return (
    <div
      className={cn("flex items-center self-stretch mr-2", containerClassName)}
      style={containerStyle}
    >
      <div
        className={cn("flex pr-4 items-center gap-2.5", labelClassName)}
        style={labelStyle}
      >
        <span className="mt-0.5 size-4 items-center justify-center text-gray-7">
          {icon}
        </span>
        <Text variant="compact-title" multiline style={{ marginTop: 2 }}>
          {label}
        </Text>
      </div>
      <div className={cn("relative", valueClassName)} style={valueStyle}>
        {children}
      </div>
    </div>
  );
};

export default InlineEditField;
